export const TOP_BAR_HEIGHT = '4.1vh';
export const HAND_HEIGHT = '20vh + 1em';
export const BG_ASPECT_RATIO = 455 / 773;

export const title = 'Clashing';
export const titlePrefix = '(1) ';
